export default __webpack_public_path__ + "static/media/hop.44bcdf66.png";